<div class="page-container estimate-list">
  <div class="page-title">
    <span translate="BUTTON.ESTIMATE_LIST"></span>
    <pop-user-card></pop-user-card>
  </div>

  <div class="toolbar">
    <i class="far fa-search"></i>
    <input type="text"
           class="list-input"
           pInputText
           size="50"
           (input)="filterTable(dt, $event.target)" />

    <button class="toolbar-btn"
            [ngClass]="{ 'filters-btn-active': showFilters }"
            (click)="showFilterSidebar()">
      <i class="far fa-filter"></i>
      <span class="toolbar-btn-text"
            translate="BUTTON.FILTERS"></span>
    </button>

    <button class="toolbar-btn"
            *ngIf="!hasCRM"
            (click)="openNewEstimationDialog()">
      <i class="far fa-plus"></i>
      <span class="toolbar-btn-text"
            translate="BUTTON.NEW_ESTIMATE"></span>
    </button>
  </div>

  <div class="pop-display-flex">
    <div [formGroup]="filterForm"
         class="filter-box"
         [class.filter-hide]="!showFilters">
      <span class="filter-header">
        {{ "BUTTON.FILTERS" | translate }}
        <i class="far fa-filter filter-icon"
           [class.inactive]="!filterApplied"
           (click)="clearFilters()"
           [matTooltip]="'TOOLTIP.CLEAR_FILTERS' | translate"
           position="below">
          <i class="far fa-times"
             [class.inactive]="!filterApplied"></i>
        </i>
      </span>

      <span class="filter-label"
            translate="TOOLBAR.STATUS"></span>
      <div class="filter-container"
           formGroupName="statuses">
        <div class="filter-container-item"
             *ngFor="let item of statusItems">
          <input class="filter-status-checkbox-input"
                 type="checkbox"
                 [id]="'status' + item.key"
                 [formControlName]="item.key" />
          <label class="filter-checkbox-label"
                 [for]="'status' + item.key"
                 [translate]="item.titleKey"></label>
        </div>
      </div>

      <span class="filter-label"
            translate="HEADER.TYPE"></span>
      <div class="filter-container"
           formGroupName="types">
        <div class="filter-container-item"
             *ngFor="let item of typeItems">
          <input class="filter-type-checkbox-input"
                 type="checkbox"
                 [id]="'type' + item.key"
                 [formControlName]="item.key" />
          <label class="filter-checkbox-label"
                 [for]="'type' + item.key"
                 [translate]="item.titleKey">
          </label>
        </div>
      </div>

      <span class="filter-label"
            translate="ESTIMATE_PROJECT.PROJECT"></span>
      <div class="filter-container"
           formGroupName="projects">
        <div class="filter-container-item"
             *ngFor="let item of projectItems">
          <input class="filter-type-checkbox-input"
                 type="checkbox"
                 [id]="'project' + item.key"
                 [formControlName]="item.key" />
          <label class="filter-checkbox-label"
                 [for]="'project' + item.key">
            <i class="fad fa-clipboard-user"
               *ngIf="item.key === 'MyProjects'"></i>
            <span [translate]="item.titleKey"></span>
          </label>
        </div>
      </div>
    </div>
    <p-table #dt
             class="pop-flex rem-fix"
             [value]="latestEstimatesUnfiltered"
             [paginator]="true"
             [rows]="15"
             [globalFilterFields]="['dateCreated','projectName','clientName','projectCode','codeRef']">
      <ng-template pTemplate="header">
        <tr>
          <th class="ref-header"
              [pSortableColumn]="'codeRef'">
            {{ "HEADER.REF" | translate }}
            <p-sortIcon [field]="'codeRef'"></p-sortIcon>
          </th>
          <th class="id-header"
              [pSortableColumn]="'projectCode'">
            {{ "PROPERTY_MODAL.ID" | translate }}
            <p-sortIcon [field]="'projectCode'"></p-sortIcon>
          </th>
          <th class="name-header"
              [pSortableColumn]="'projectName'">
            {{ "TABLE.DESCRIPTION" | translate }}
            <p-sortIcon [field]="'projectName'"></p-sortIcon>
          </th>
          <th class="estimate-status-header">Type</th>
          <th class="revision-header"
              translate="HEADER.REV"></th>
          <th class="client-header"
              [pSortableColumn]="'clientName'">
            {{ "HEADER.CLIENT" | translate }}
            <p-sortIcon [field]="'clientName'"></p-sortIcon>
          </th>
          <th class="creation-header"
              [pSortableColumn]="'dateCreated'">
            {{ "MODAL.DATE_CREATION" | translate }}
            <p-sortIcon [field]="'dateCreated'"></p-sortIcon>
          </th>
          <th class="estimate-status-header"
              translate="HEADER.STATUS"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"
                   let-estimate>
        <tr [routerLink]="['/app/estimate-detail', estimate.id]"
            class="pointer">
          <td class="ref-row">{{ estimate.codeRef }}</td>
          <td class="ref-row">{{ estimate.projectCode }}</td>
          <td class="name-row">{{ estimate.projectName }}</td>
          <td class="estimate-status-row"
              [translate]="estimate.estimateType | enumLabel: 'ESTIMATE_TYPE'"></td>
          <td class="revision-row">{{ estimate.revision }}</td>
          <td class="client-row">{{ estimate.clientName }}</td>
          <td class="creation-row">
            {{ estimate.dateCreated | dateFormat: "DDD" }}
          </td>
          <td class="estimate-status-row"
              [translate]="estimate.status | enumLabel: 'STATUS'"></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<pop-create-estimate *ngIf="isCreateEstimateOpen"></pop-create-estimate>
